import { isExpectedInstallment } from "./bank-posting";
import { installmentIsDue } from "./installments";
import { pendingBreakdown } from "./pending";
import type { Movement } from "./types";

/** Sólo presentación: cargo, cobertura y pago se derivan por separado. */
export function installmentJourney(movement: Movement, today: string) {
  const paid = movement.cardPaymentStatus === "paid" || Boolean(movement.historicalSettlement);
  const expected = isExpectedInstallment(movement);
  const pending = pendingBreakdown(movement);
  const actionable = installmentIsDue(movement, today);
  const next = paid ? "history" : expected ? "confirm" : pending.ownPendingCents > 0
    ? actionable ? "fund" : "wait" : pending.reimbursementPendingCents > 0
      ? actionable ? "reimbursement" : "wait" : "payment";
  return {
    paid, expected, next,
    cargo: paid ? "Pagada al banco" : expected ? "Cargo previsto" : movement.installmentNumber === 1 ? "Cargo registrado al capturar" : "Cargo confirmado",
    money: paid ? "Pago registrado" : pending.ownPendingCents > 0 ? "Dinero propio por apartar"
      : pending.reimbursementPendingCents > 0 ? "Tu parte cubierta · falta reembolso" : expected ? "Dinero apartado · cargo por confirmar" : "Dinero apartado · falta pagar al banco",
    guidance: paid ? "Esta parcialidad forma parte de un corte pagado."
      : expected ? "Confirma cuando veas este cargo en el banco. Apartar dinero antes no lo confirma."
      : next === "fund" ? "El cargo ya está registrado. Puedes abonar una parte o completar lo que falta para el pago de la tarjeta."
      : next === "reimbursement" ? "Tu parte está cubierta. Registra el reembolso cuando lo recibas; el pago al banco sigue pendiente."
      : next === "wait" ? "El cargo está registrado. Podrás completar su cobertura cuando comience el corte asignado."
      : "Ya está cubierta. Sigue debiéndose al banco hasta registrar el pago real del corte; consúltala en tu tarjeta aunque ya no aparezca en Pendientes.",
  };
}
